import { useLanguage } from '../context/LanguageContext';

export default function Privacy() {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-cream-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-primary-800 dark:bg-primary-900 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
            {t('privacy.title')}
          </h1>
          <p className="text-primary-200">
            {t('privacy.lastUpdated')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="prose prose-lg dark:prose-invert max-w-none">
          {language === 'de' ? (
            <>
              <h2>1. Verantwortlicher</h2>
              <p>
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
                Bella Vista (Demo)<br />
                Maximilianstraße 45<br />
                80539 München
              </p>

              <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
              <p>
                Diese Website ist ein Demo-Projekt. Es werden keine echten personenbezogenen
                Daten erhoben oder verarbeitet. Formulareingaben werden nicht gespeichert
                oder übermittelt.
              </p>

              <h2>3. Cookies</h2>
              <p>
                Diese Demo-Website verwendet lokale Speicherung (localStorage) für:
              </p>
              <ul>
                <li>Speicherung der Spracheinstellung</li>
                <li>Speicherung der Theme-Präferenz (Hell/Dunkel)</li>
                <li>Speicherung der Cookie-Banner-Entscheidung</li>
              </ul>

              <h2>4. Externe Dienste</h2>
              <p>
                Diese Website lädt Bilder von Unsplash und Schriftarten von Google Fonts.
                Dabei können Daten an diese Dienste übermittelt werden.
              </p>

              <h2>5. Demo-Hinweis</h2>
              <p>
                <strong>Dies ist eine Demo-Website für Portfolio-Zwecke.</strong> Bella Vista
                ist ein fiktives Restaurant. Alle Kontaktdaten, Preise und Informationen
                sind beispielhaft.
              </p>
            </>
          ) : (
            <>
              <h2>1. Data Controller</h2>
              <p>
                Responsible for data processing on this website:<br />
                Bella Vista (Demo)<br />
                Maximilianstraße 45<br />
                80539 Munich, Germany
              </p>

              <h2>2. Collection and Processing of Personal Data</h2>
              <p>
                This website is a demo project. No real personal data is collected or
                processed. Form submissions are not stored or transmitted.
              </p>

              <h2>3. Cookies</h2>
              <p>
                This demo website uses local storage for:
              </p>
              <ul>
                <li>Storing language preference</li>
                <li>Storing theme preference (Light/Dark)</li>
                <li>Storing cookie banner decision</li>
              </ul>

              <h2>4. External Services</h2>
              <p>
                This website loads images from Unsplash and fonts from Google Fonts.
                Data may be transmitted to these services.
              </p>

              <h2>5. Demo Notice</h2>
              <p>
                <strong>This is a demo website for portfolio purposes.</strong> Bella Vista
                is a fictional restaurant. All contact information, prices, and details
                are examples only.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
